import ApiService from "@/modules/api/api.service";

export default class ShippingManifestExportsRepository {
  protected fResourceName = "shipping_manifest_exports";

  constructor(protected api: ApiService) {}

  public async getPdfByBulkShipmentId(bulkShipmentId: string): Promise<string> {
    const result = await this.api.get(
      `${this.fResourceName}/${bulkShipmentId}/pdf`
    );

    return (result.data as { downloadUrl: string }).downloadUrl;
  }
}
